<script>

import ExportBtn from "@/components/export/ExportBtn.vue";
import SelectArtist from "@/components/Selects/artist.vue";
import CompanySelect from "@/views/adOrder/components/companySelect.vue";
import {
  confirmIncome,
  ensureIncomeExportList,
  ensureIncomeList, exportLiveGuaranteeList, getIncomeSummaryStat,
  getLiveGuaranteeList,
  setAssistant
} from "@/api/incomeSummary";
import moment from "moment/moment";
// import {getAuthUser} from "@/utils/auth";
import {isArray} from "lodash";

export default {
  components: {CompanySelect, SelectArtist, ExportBtn},
  data() {
    return {
      selectedData: [],
      user_aid: null,//助理
      tableData: [],
      loading: false,
      doLoading: false,
      total: 0,
      query: {
        page: 1,
        page_size: 20,
        scope_type: 'mine',
        type: 'money',
        order_by: null,
        date_check: null,
        artist_id: null,
        company_id: null,
        date_range: [],
        is_confirm: null,
        is_notify: 'Y',
        agent_name: null
      },
      // showOnlyMine: true,
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      total_amount: 0,
      sum_amount: 0,
      total_accrue_amount: 0,
      sum_accrue_amount: 0,
      confirmDialogVisible: false,
      dialogTitle: '确认订单',
      showAssistant: false,
      confirmType: '',
      ensureIncomeList: ensureIncomeList,
    }
  },
  computed: {
    confirmTotalAmount() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.artist_rate_amount / 1;
      });
      return total;
    }
  },
  created() {
    this.query.date_check = moment().subtract(1, 'month').format('YYYY-MM');
    this.getTableData(true)
  },
  methods: {
    open(scopeType) {
      //清空勾选
      this.$refs.multipleTable.clearSelection()
      // this.$notify.warning(scopeType)
      this.query.scope_type = scopeType
      this.handleSearch()
      this.handleGetSummary()
    },
    HandleSelectAll(selection) {

      if (selection.length === 0) {
        //取消全选
        // 取消的数据对象 tableData
        this.tableData.forEach((row) => {
          let index = this.selectedData.findIndex(value => value.l_g_id === row.l_g_id)
          if (index > -1)
            this.selectedData.splice(index, 1)
        })
      } else {
        selection.map((row) => {
          let index = this.selectedData.findIndex(value => value.l_g_id === row.l_g_id)
          index === -1 && this.selectedData.push(row)
        })
      }
      // 计算可结算收入合计
      this.sumAmount();
      this.sumAccrueAmount();
    },
    changeTableSort(_) {
      const {prop, order} = _
      let order_by = null
      if (order) {
        order_by = order === 'ascending' ? `\`${prop}\` asc` : `\`${prop}\` desc`
      }
      this.queryParams.order_by = order_by
      this.getTableData()
    },
    clearData() {
      // this.pageSelectedList = []
      this.selectedData = [];
      // 重置合计
      this.sum_amount = 0;
      this.sum_accrue_amount = 0;
      // this.$refs['refTableAdOrder'].handleClearSelection()
    },
    eventSizeChange: function (page_size) {
      this.query.page_size = page_size
      this.handleSearch()
    },
    eventSortMethod: function ({order, prop}) {
      let string = null;
      switch (order) {
        case 'descending':
          string = `${prop} desc`
          break;
        case 'ascending':
          string = `${prop} asc`
          break;
        default:
          break;
      }
      this.query.order_by = string
      this.getTableData(true)
    },
    getSearch: function () {
      this.query.date_check = this.query.date_check ? moment(this.query.date_check).format('YYYY-MM') + '-01' : null
      let condition = {}
      Object.keys(this.query).forEach((field) => {
        if (this.query[field] != null && this.query[field]) {
          if (isArray(this.query[field])) {
            if (this.query[field].length > 0)
              condition[field] = this.query[field]
          } else
            condition[field] = this.query[field]
        }
      })
      return condition
    },
    getTableData: async function (is_search = false) {
      this.tableData = []
      this.sum_amount = 0;
      this.sum_accrue_amount = 0;
      this.selectedData = []
      // 查询重置 page
      if (is_search) {
        // this.query.page = 1
        this.total_amount = 0;
      }
      const query = this.getSearch()
      this.loading = true
      let result = null
      if (this.query.scope_type === 'all') {
        result = await ensureIncomeList(query)
      } else {
        result = await getLiveGuaranteeList(query)
      }

      const {success, model} = result
      this.loading = false
      if (!success) {
        return;
      }
      const {data, total, sum_amount, sum_accrue_amount} = model
      this.tableData = data || []
      this.total = total || 0
      this.total_amount = sum_amount || 0
      this.total_accrue_amount = sum_accrue_amount || 0

    },
    //确认订单
    handleConfirm(confirm_type) {
      this.confirmType = confirm_type
      this.confirmDialogVisible = true;
      this.dialogTitle = `确认${this.confirmType}订单`
      this.showAssistant = false;
    },
    //确认订单
    handleToAssistantConfirm() {
      this.confirmDialogVisible = true;
      this.showAssistant = true;
      this.dialogTitle = '转交经纪人助理'
    },
    changeAgent(val) {
      if (val.id) {
        this.user_aid = val.id
      } else {
        this.user_aid = null
      }
    },
    //转交给助理
    async submitToAssistant() {
      try {
        const ids = this.selectedData.map(item => item.l_g_id);
        if (ids.length === 0) {
          this.$notify.warning('至少选择一个订单')
          return false;
        }
        if (!this.user_aid) {
          this.$notify.warning('请选择转交人')
          return false;
        }
        const {success} = await setAssistant('ensure', ids, this.user_aid);

        if (success) {
          this.msgSuccess('确认成功');
          this.confirmDialogVisible = false;
          // 刷新数据
          this.getTableData();
        } else {
          this.$message.error('确认失败，请重试');
        }
      } catch (error) {
        this.$message.error('确认失败，请重试');
      }
    },
    //
    handleCurrentChange: function (page) {
      this.query.page = page
      this.getTableData()
    },
    //预览数据-清空
    handleSearch: function () {
      this.query.page = 1
      this.getTableData(true)
    },
    changeUserAid(item) {
      this.query.user_aid = item.id || 0
    },
    //当选择项发生变化时会触发该事件
    handleSelectRow(selection, row) {
      if (selection.indexOf(row) === -1) {
        // console.log('取消选中')
        let index = this.selectedData.findIndex(value => value.l_g_id === row.l_g_id)
        // this.$notify.info(`取消第${index}行`)
        if (index > -1)
          this.selectedData.splice(index, 1)
      } else {
        this.selectedData.push(row)
      }
      // 计算可结算收入合计
      this.sumAmount();
      this.sumAccrueAmount();
    },
    //
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2)
    },
    async submitConfirm() {
      try {
        const ids = this.selectedData.map(item => item.l_g_id);
        const params = {
          ids: ids,
          type: 'ensure',
          confirm_type: this.confirmType,
        };
        const {success} = await confirmIncome(params);

        if (success) {
          this.msgSuccess('确认成功');
          this.confirmDialogVisible = false;
          // 刷新数据
          await this.getTableData();
          // 清空已选
          this.clearData()
        } else {
          this.$message.error('确认失败，请重试');
        }
      } catch (error) {
        this.$message.error('确认失败，请重试');
      }
    },
    // 确认按钮点击事件
    sumAccrueAmount() {
      let total = 0;
      this.selectedData.map((item) => {
        total += item.accrue_amount / 1
      })
      this.sum_accrue_amount = total
    },
    // 提交确认
    sumAmount() {
      let total = 0;
      this.selectedData.map((item) => {
        total += item.stage_amount / 1
      })
      this.sum_amount = total
    },
    handleExport: async function () {
      try {
        const query = this.getSearch()
        const response = await ensureIncomeExportList(query)
        this.$refs.refExportBtn.exportSaveXlsx(response, '全案保量-经纪确认导出')
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    handleNotAllExport: async function () {
      try {
        const query = this.getSearch()
        const response = await exportLiveGuaranteeList(query)
        this.$refs.refExportNotAllBtn.exportSaveXlsx(response, '全案保量-经纪确认导出')
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    handleGetSummary(){
      const query = this.getSearch()
      getIncomeSummaryStat(query)
    }
  }
}
</script>

<template>
  <div>
    <div>
      <div>
        <el-form :model="query" size="mini" inline>
          <el-form-item>
            <el-date-picker style="width: 220px" v-model="query.date_range" type="monthrange" align="right"
                            size="mini" format="yyyy年MM月" value-format="yyyy-MM" unlink-panels range-separator="至"
                            start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="query.date_check" type="month" format="yyyy年MM月" value-format="yyyy-MM"
                            placeholder="搜索月份" size="mini" style="width: 130px" @change="handleSearch"/>
          </el-form-item>
          <el-form-item>
            <el-input v-model="query.brand" placeholder="品牌" @change="handleSearch" clearable/>
          </el-form-item>
          <el-form-item>
            <el-input @change="handleSearch" v-model="query.agent_name"  v-if="this.query.scope_type!=='mine'"
                      placeholder="经纪人"
                      clearable/>
          </el-form-item>
          <el-form-item label="">
            <UserSearch @handleSelect="changeUserAid" placeholder="转交人"
                        v-if="this.query.scope_type!=='toMe'"></UserSearch>
          </el-form-item>
          <el-form-item>
            <select-artist :value.sync="query.artist_id" size="mini" @change="handleSearch"/>
          </el-form-item>
          <el-form-item>
            <company-select :company-id.sync="query.company_id" @selected="handleSearch"/>
          </el-form-item>
          <el-form-item>
            <el-select style="width: 100px" v-model="query.is_confirm" placeholder="确认状态" clearable
                       @change="handleSearch" size="mini">
              <el-option label="已确认" value="Y"></el-option>
              <el-option label="未确认" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <export-btn v-if="this.query.scope_type==='all'" v-permission="'ensure_income_confirm__list'" size="mini" :can-export="true" btn-type="warning"
                        @export="handleExport('refExportBtn')" ref="refExportBtn" :lint-title="`导出`"/>
            <export-btn v-if="this.query.scope_type!=='all'" v-permission="'ensure_income_confirm__list'" size="mini" :can-export="true" btn-type="warning"
                        @export="handleNotAllExport('refExportNotAllBtn')" ref="refExportNotAllBtn" :lint-title="`导出`"/>
          </el-form-item>
          <div>
            <el-form-item>
              <el-button v-permission="'ensure_income_confirm__btn'" type="success" size="mini"
                         :disabled="selectedData.length === 0" @click="handleConfirm('品宣')">
                确认品宣订单
              </el-button>
              <el-button v-permission="'ensure_income_confirm__btn'" type="success" size="mini"
                         :disabled="selectedData.length === 0" @click="handleConfirm('直播')">
                确认直播订单
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button v-if="this.query.scope_type!=='toMe'"
                         v-permission="'ensure_income_confirm__btn'"
                         type="primary" round plain size="mini"
                         :disabled="selectedData.length === 0"
                         @click="handleToAssistantConfirm">
                转交助理
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
        <el-table border
                  :data="tableData"
                  ref="multipleTable"
                  @sort-change="eventSortMethod"
                  @select-all="HandleSelectAll" @select="handleSelectRow">
          <el-table-column type="selection" width="55"/>
          <el-table-column label="#" type="index"/>
          <el-table-column label="核算月份" prop="date_check" align="center" sortable width="120">
            <template v-slot="{ row: { date_check } }">
              <b>{{ date_check | parseTime('{y}年{m}月') }}</b>
            </template>
          </el-table-column>
          <el-table-column label="红人名称" prop="nickname" align="center" width="120"/>
          <el-table-column label="经纪人" prop="agent_name" align="center" width="160">
            <template slot-scope="{ row }">
              <b>{{ row.agent_name }}
                <span v-if="row.user_aid" :title="`转交时间：${row.transfer_at}`">
                  <span class="el-icon-right" style="color: red" ></span>
                 『{{ row.assistant.name || '--' }}』
                </span>
              </b>
            </template>
          </el-table-column>
          <el-table-column label="确认状态" prop="is_confirm" show-overflow-tooltip width="90">
            <template v-slot="{ row: { is_confirm } }">
              <div style="display: flex; align-items: center; gap: 4px;">
                <el-tag v-if="is_confirm === 'Y'" type="success" size="mini">已确认</el-tag>
                <b v-else>未确认</b>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="确认类型" prop="confirm_type" show-overflow-tooltip width="90" header-align="center" align="center"/>
          <el-table-column label="平台" prop="platform" show-overflow-tooltip width="80"/>
          <el-table-column label="保量进度" prop="stage_schedule" header-align="right" align="right" sortable
                           width="120">
            <template v-slot="{ row: { stage_schedule } }">
              <div class="rate">{{ stage_schedule | numberFormat(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="可结算收入" prop="stage_amount" header-align="right" align="right" sortable
                           width="120">
            <template v-slot="{ row: { stage_amount } }">
              <b class="money">{{ stage_amount | numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="累计保量进度" prop="accrue_schedule" header-align="right" align="right" sortable
                           width="120">
            <template v-slot="{ row: { accrue_schedule } }">
              <div class="rate">{{ accrue_schedule | numberFormat(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="累计可结算收入" prop="accrue_amount" header-align="right" align="right" sortable
                           width="130">
            <template v-slot="{ row: { accrue_amount } }">
              <b class="money">{{ accrue_amount | numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="分成比例" prop="artist_rate" header-align="right" align="right" sortable width="130">
            <template v-slot="{ row: { artist_rate } }">
              <b class="rate">{{ artist_rate | numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="分成金额" prop="artist_rate_amount" header-align="right" align="right" sortable
                           width="130">
            <template v-slot="{ row: { artist_rate_amount } }">
              <b class="money">{{ artist_rate_amount | numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="订单编号" algin="center" width="150">
            <template v-slot="{ row }">
              {{ row.order_no || '' }}
              <!--            <to-order-detail by-field="order_no" :order="{ order_no: row.order_no, order_id: row.id }"/>-->
            </template>
          </el-table-column>
          <el-table-column label="乙方名称" prop="company_name" show-overflow-tooltip/>
          <el-table-column label="客户性质" prop="customer_nature" show-overflow-tooltip/>
          <el-table-column label="品牌" prop="brand" show-overflow-tooltip/>
          <el-table-column label="行业" prop="trade" show-overflow-tooltip/>
          <el-table-column label="产品/内容" prop="product" width="120" show-overflow-tooltip/>
          <el-table-column label="订单来源" prop="order_source" show-overflow-tooltip/>
          <el-table-column label="客单" prop="passenger_order_interval" show-overflow-tooltip/>
          <el-table-column label="品类" prop="product_category" show-overflow-tooltip/>
          <el-table-column label="合作形式" prop="form_of_cooperation" show-overflow-tooltip/>
          <el-table-column label="含税收入" width="110" header-align="center" align="right" prop="payment_account" show-overflow-tooltip>
            <template v-slot="{row,column}">
             <div class="money">{{moneyFormat(row[column.property])}}</div>
            </template>
          </el-table-column>
          <el-table-column label="回款金额" width="110" header-align="center" align="right" prop="sum_amount" show-overflow-tooltip>
            <template v-slot="{row,column}">
              <div class="money">{{moneyFormat(row[column.property])}}</div>
            </template>
          </el-table-column>
          <el-table-column label="应收款" width="110" header-align="center" align="right" prop="remain_account" show-overflow-tooltip>
            <template v-slot="{row,column}">
              <div class="money">{{moneyFormat(row[column.property])}}</div>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" show-overflow-tooltip/>
          <el-table-column label="收款形式" prop="payment_method_alias" show-overflow-tooltip/>
          <el-table-column label="合同归档" prop="contract_filed_alias" show-overflow-tooltip/>
          <el-table-column label="合同编号" prop="contract_no" show-overflow-tooltip/>
          <el-table-column label="合同金额" width="110" header-align="center" align="right" prop="contract_amount" show-overflow-tooltip>
            <template v-slot="{row,column}">
              <div class="money">{{moneyFormat(row[column.property])}}</div>
            </template>
          </el-table-column>
          <el-table-column label="财务备注" prop="f_remark" width="300" show-overflow-tooltip/>
          <el-table-column label="是否保次" prop="is_quantity_times_alias" width="100" align="center" show-overflow-tooltip/>
          <el-table-column label="直播次数" prop="live_count" width="100" align="center" show-overflow-tooltip/>
          <el-table-column label="是否保量" prop="is_quantity_alias" width="100" align="center" show-overflow-tooltip/>
          <el-table-column label="保量金额" prop="gq_amount" width="110" header-align="center" align="right" show-overflow-tooltip>
            <template v-slot="{row,column}">
              <div class="money">{{moneyFormat(row[column.property])}}</div>
            </template>
          </el-table-column>
          <el-table-column label="是否完结" prop="is_done_order" width="100" align="center" show-overflow-tooltip>
            <template v-slot="{ row: { is_done_order } }">
              {{ is_done_order == 0 ? '未完结' : '已完结' }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="140" align="center" show-overflow-tooltip/>
        </el-table>
        <div>
          <div class="flex flex-justify-sb">
            <div>
              <div class="bottom-bar">
                <div
                    style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center">
                  <div style="font-weight: bold;display: flex">
                    <span style="margin-right: 10px;font-size: 1.2rem;line-height: 3.5">合计：</span>
                    <span style="margin-right: 10px;">可结算收入：
                    <span class="money" style="font-size: 1.2rem;line-height: 3.5">{{
                        moneyFormat(sum_amount)
                      }}（{{ moneyFormat(total_amount) }}）</span>
                  </span>
                    <span style="margin-right: 10px;">累计可结算收入：
                    <span class="money" style="font-size: 1.2rem;line-height: 3.5">{{
                        moneyFormat(sum_accrue_amount)
                      }}（{{ moneyFormat(total_accrue_amount) }}）</span>
                  </span>
                    <!--                  <span style="margin-right: 10px">可结算总收入：-->
                    <!--                    <span style="font-size: 1.2rem;line-height: 3.5">{{ moneyFormat(total_amount) }}</span>-->
                    <!--                  </span>-->
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: right">
              <el-pagination background :current-page="query.page" :page-sizes="[5, 10, 20, 100, 200, 300, 400]"
                             :page-size="query.page_size" layout="total, sizes, prev, pager, next" :total="total"
                             style="margin-top: 10px;float: right;" @current-change="handleCurrentChange"
                             @size-change="eventSizeChange"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 确认弹框 -->
    <el-dialog :title="dialogTitle" center :visible.sync="confirmDialogVisible" width="800px"
               :close-on-click-modal="false">
      <div>
        <el-table :data="selectedData" border size="mini">
          <el-table-column label="核算归属月份" width="120">
            <template v-slot="{ row }">
              {{ row.date_check | parseTime('{y}年{m}月') }}
            </template>
          </el-table-column>
          <el-table-column label="红人名称" prop="nickname" width="130"/>
          <el-table-column label="经纪人" prop="agent_name" width="90"/>
          <el-table-column label="订单编号" align="right" width="120">
            <template v-slot="{ row }">
              {{ row.order_no }}
              <!--              <to-order-detail by-field="order_no" :order="{ order_no: row.order_no, order_id: row.id }" />-->
            </template>
          </el-table-column>
          <el-table-column label="可分配收入" align="right" width="120">
            <template v-slot="{ row: { stage_amount } }">
              <b>￥{{ stage_amount | numberFormat(2) }}</b>
            </template>
          </el-table-column>
          <el-table-column label="分成金额" align="right" width="120">
            <template v-slot="{ row }">
              ￥{{ row.artist_rate_amount | numberFormat(2) }}
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; text-align: right; font-weight: bold;">
          总计分成金额：￥{{ moneyFormat(confirmTotalAmount) }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div style="display: flex;  flex-direction: row;  justify-content: center;  gap: 10px;">
          <UserSearch class="el-input-c-m" @handleSelect="changeAgent" placeholder="转交人（姓名模糊搜索）" v-if="showAssistant" style="width: 300px"/>
          <div>
            <!--            <el-button @click="confirmDialogVisible = false">取消</el-button>-->
            <el-button type="primary" round @click="submitToAssistant" v-if="showAssistant">确定转交</el-button>
            <el-button type="primary" @click="submitConfirm" v-else>确定确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<style>

</style>